<div class="alert-container" *ngIf="show && !isToast" (click)="close()">
  <div class="card" [ngStyle]="{transform: translate}" (click)="$event.stopPropagation()">
    <div class="card-body">
      <h5>{{ message }}</h5>
    </div>
    <div class="card-footer">
      <button class="btn btn-primary" (click)="close()">OK</button>
    </div>
  </div>
</div>


<div *ngIf="show && isToast"
  style="
    position:fixed;
    bottom:20px;
    right:20px;
    background:rgba(20, 20, 20, 0.55);;
    color:white;
    padding:20px;
    z-index:9999999;">
  {{message}}
</div>